<template>
  <v-autocomplete
    v-model="internalValue"
    :items="users"
    :multiple="!!multiple"
    item-text="name"
    item-value="_id"
    return-object
    chips
    :search-input.sync="search"
    :loading="loading"
    no-data-text="Danh sách trống"
    clearable
    @change="onChange"
    v-bind="$attrs"
    @input="$emit('input', $event)"
  >
    <template v-slot:selection="data">
      <template v-if="data.index === 0">
        <div v-if="multiple" class="d-flex flex-wrap align-center">
          <v-chip
            v-for="user in internalValue.slice(0, 7)"
            :key="user._id"
            class="ma-1"
            small
            close
            @click:close="remove(user)"
          >
            <v-avatar left color="white">
              <img :src="avatar(user)" alt="avatar" />
            </v-avatar>
            {{ user.name }}
          </v-chip>
          <v-tooltip top v-if="internalValue.length > 7">
            <template #activator="{ on, attrs }">
              <div class="avatar-wrapper mr-2" v-on="on" v-bind="attrs">
                <v-avatar size="24" color="grey lighten-1">
                  <span class="white--text font-weight-bold text-caption"> +{{ internalValue.length - 7 }} </span>
                </v-avatar>
              </div>
            </template>
            <span>
              {{
                internalValue
                  .slice(7)
                  .map(u => u.name)
                  .join(', ')
              }}
            </span>
          </v-tooltip>
        </div>
        <div v-else class="d-flex align-center">
          <span>{{ internalValue.name || internalValue }}</span>
        </div>
      </template>
    </template>

    <template v-slot:item="data">
      <template>
        <v-list-item-content>
          <CardUserExcludeInfo :user="data.item" :isSelected="isSelected(data.item)" :multiple="!!multiple" />
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import CardUserExcludeInfo from '@/components/basic/card/CardUserExcludeInfo.vue'
import get from 'lodash-es/get'
import { mapActions } from 'vuex'

export default {
  components: {
    CardUserExcludeInfo,
  },
  props: {
    multiple: Boolean,
    syncedValue: {
      type: [Array, Object, String],
      default: () => [],
    },
    defaultPeoples: {
      type: Array,
      default: () => [],
    },
    filter: Object,
    options: Object,
  },
  data() {
    return {
      internalValue: this.syncedValue,
      users: [],
      search: '',
      loading: false,
    }
  },
  watch: {
    syncedValue: {
      async handler(val) {
        if (this.multiple) {
          this.internalValue = Array.isArray(val) ? val : []
        } else {
          if (typeof val === 'string') {
            const matched = this.users.find(u => u._id === val)
            this.internalValue = matched || val
          } else {
            this.internalValue = val
          }
        }
      },
      immediate: true,
      deep: true,
    },
    filter: {
      handler() {
        this.fetchUsers()
      },
      immediate: true,
    },
  },
  methods: {
    isSelected(item) {
      if (this.multiple) {
        return Array.isArray(this.internalValue) && this.internalValue.some(u => u._id === item._id)
      } else {
        return this.internalValue === item._id || (this.internalValue && this.internalValue._id === item._id)
      }
    },

    remove(item) {
      if (this.multiple) this.internalValue = this.internalValue.filter(u => u._id !== item._id)
      else this.internalValue = null
    },
    ...mapActions({
      findUsersExcludeRoles: 'tasknew/findUsersExcludeRoles',
    }),
    async fetchUsers(keyword = '') {
      this.loading = true
      const res = await this.findUsersExcludeRoles({
        keyword: keyword,
      })
      this.users = res
      this.loading = false
    },
    avatar(item) {
      return get(item, 'avatar.url', require('@/assets/default-avatar.svg'))
    },
    onChange(data) {
      this.internalValue = data

      let result
      if (this.multiple) {
        result = Array.isArray(data) ? data : []
      } else {
        if (!data) {
          result = null
        } else if (typeof data === 'object') {
          result = data._id
        } else {
          result = data
        }
      }
      this.$emit('update:syncedValue', result)
      this.$emit('change', result)
    },
  },
}
</script>

<style scoped>
.avatar-wrapper {
  position: relative;
  display: inline-block;
}

.remove-btn {
  position: absolute;
  top: 0px;
  right: -10px;
  min-width: 3px;
  height: 6px;
  border-radius: 50%;
  padding: 0;
  z-index: 2;
}
</style>
